import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import TruncateString from 'react-truncate-string'
import { BASE } from '../api/api'
import { List } from 'react-content-loader'
import Axios from 'axios'
import cachios from 'cachios'
import pr from '../assets/pr.jpg'
import load from '../assets/loading.gif'
import Loader from 'react-loader'
import Header from '../header/newheader'
import Footer from '../footer/footerbkp';
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar';


class Faculty extends Component {
  constructor(props) {
    super(props);
    console.log(props, "123")
    this.state = {
      people: '',
      bioimage: '',
      imagearray: '',
      limit: 15,
      offset: props.match.params.page ? parseInt(props.match.params.page, 10) : 0,
      next: false,
      prev: false,
      filter: props.match.params.filter ? props.match.params.filter : '',
      filterchk: props.match.params.section ? props.match.params.section : '',
      page: props.match.params.page ? parseInt(props.match.params.page, 10) : 0,
      type: 'faculty'
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.path === '/research/faculty') {
      this.setState({
        offset: 0,
        page: 0,
        filter: '',
        filterchk: ''
      })
      this.apicall(0, '')
    }
    else
      this.apicall(nextProps.match.params.page, nextProps.match.params.filter)


  }

  //filter list
  filterlist() {
    cachios.get(BASE + 'api/faculty_filter_list', {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        console.log(data, 'found')

        this.setState({
          filterlist: data.data.data,
        })
      })
      .catch((err) => {
        console.log('not found')
      })
  }
  //setting filter and apicall
  setfilter(type, value, programe_name) {
    let filterchk = this.state.filterchk
    console.log(filterchk, type, 'filterchk')
    if(programe_name){
      localStorage.setItem('related_faculty_head', programe_name)
    }
    else{
      localStorage.setItem('related_faculty_head', value)
    }
    if (filterchk != value && value !== "Faculty") {

      this.setState({
        people: '',
        filter: 'faculty[0]=' + type + ':' + value,
        filterchk: value
      })
      if (value != "") {
        this.props.history.push('/research/faculty/section/' + value + '/' + 'faculty[0]=' + type + ':' + value + '/' + 0)
        this.setState({
          offset: 0
        })
      }
      else {
        
        this.props.history.push('/research/faculty')
        this.setState({
          offset: 0
        })
      }
    }
  }
  settype(type) {
    this.setState({
      type: type
    })
    this.setState({
      page: 0,
      offset: 0
    })
    this.props.history.push('/research/' + type)

  }
  //Next/previous click function
  handlePageClick = data => {
    console.log(data, 'offset')

    let filterchk = this.state.filterchk ? this.state.filterchk : 'all'
    let filter = this.state.filter ? this.state.filter : 'all'

    if (data === 'next' && this.state.next === true) {
      this.setState({
        people: '',
      })
      this.props.history.push('/research/faculty/section/' + filterchk + '/' + filter + '/' + (parseInt(this.state.offset, 10) + 1))
      this.setState({
        offset: parseInt(this.state.offset, 10) + 1
      })
      // history.push('/faculty?page='+this.state.offset)

    }
    else if (data === 'prev' && this.state.prev === true) {
      this.setState({
        people: '',
      })
      this.props.history.push('/research/faculty/section/' + filterchk + '/' + filter + '/' + (parseInt(this.state.offset, 10) - 1))
      this.setState({
        offset: parseInt(this.state.offset, 10) - 1
      })
      // this.apicall(this.state.offset-1,this.state.filter)
    }
  };

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  filterapi() {
    Axios.get(BASE + 'api/faculty_search', {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        console.log(data, 'xxx')
        this.setState({
          people: data.data.data
        })
      })
  }
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.signout()
    }
  }




  componentWillMount() {
    if (localStorage.getItem('token'))
      this.checkexpiry()
    this.filterlist()
    this.apicall(this.state.offset, this.state.filter)
    localStorage.removeItem('faculty');
    localStorage.removeItem('facultypub');

  }
  pagestore(id) {

    localStorage.setItem('pagenum', JSON.stringify(id))

  }
  apicall(id, filter) {
    localStorage.removeItem('pagenum')
    if (id <= 0) {
      this.setState({
        prev: false,
      })
    }
    else {
      this.setState({
        prev: true
      })
    }
    //to check Next page
    console.log('filter present' + filter)
    console.log('filterchck ' + this.state.filterchk)
    if (filter == '' || filter == 'all') {
      cachios.get(BASE + 'api/faculty_search_landing_page', {
        ttl: 500 /* seconds */,
      })
        .then((data) => {
          if (localStorage.getItem('token'))
            this.checkexpiry()
          console.log(data, 'xxx')
          this.setState({
            people: data.data.data,
          })
          this.topFunction();
        })
        .catch((err) => {
          console.log('not found')
        })
    }
    else {
      Axios(BASE + 'api/faculty_search?' + filter , {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
        .then((data) => {
          console.log(data.data, 'next')
          //HIDE/SHOW  NEXT button
          if (data.data.data.length === 0) {
            this.setState({
              next: false,
            })
          }
          else {
            this.setState({
              next: true
            })
          }
        })
      cachios.get(BASE + 'api/faculty_search?' + filter , {
        ttl: 500 /* seconds */,
      })
        .then((data) => {
          if (localStorage.getItem('token'))
            this.checkexpiry()


          console.log(data, 'xxx')
          this.setState({
            people: data.data.data,
          })
          localStorage.setItem('related_faculty', JSON.stringify(data.data.data))
          // localStorage.setItem('related_faculty', s)

          this.topFunction();
        })
        .catch((err) => {
          console.log('not found')
        })
    }

    console.log(BASE + 'api/faculty_search?' + filter + '&page=' + (id), "123321", this.state.filterchk)

  }
  render() {

    return (
      <div>
        <Header />
        {/* <div className="container">
          <div className="tabsection">
            <button style={{ backgroundColor: this.state.type === 'division' ? '#165E84' : '' }} onClick={() => this.settype('division')}>Research Division</button>
            <button style={{ backgroundColor: this.state.type === 'cluster' ? '#165E84' : '' }} onClick={() => this.settype('cluster')}>Research Cluster</button>
            <button style={{ backgroundColor: this.state.type === 'faculty' ? '#165E84' : '' }} onClick={() => this.settype('faculty')}>Faculty</button>
          </div>
        </div> */}
        <div className='container'>


          <div className="page-people" >
            <div className='top-contents'>
              <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/research/faculty'>CIS Faculty</Link></div>
              {/* <TopBar data={'data1'} /> */}
            </div>

            <div className="page-title">
              <div className="title-wrapper">
                <div className="">
                  <h1 className="heading">CIS Faculty</h1>
                </div>
              </div>
            </div>
            <div className="main-content">
              <div className="">
                <div className='faculty_container'>
                  <div className='faculty_filter'>
                    {this.state.filterlist ?
                      this.state.filterlist.data_faculty_type.map((value, ind) => {
                        return <div>
                          <div style={{ cursor: value.field_faculty_type === "Faculty" ? 'normal' : '', fontWeight: this.state.filterchk === value.field_faculty_type ? '500' : '', backgroundColor: this.state.filterchk === value.field_faculty_type ? '#165E84' : '', color: this.state.filterchk === value.field_faculty_type ? 'white ' : '' }} onClick={() => this.setfilter('faculty_type', value.field_faculty_type)} className='faculty_filter_value'>
                            {value.field_faculty_type ? value.field_faculty_type : 'All Faculty'}
                          </div>
                          {value.field_faculty_type === 'Faculty' ?
                            <div className='faculty_subfilter'>
                              {this.state.filterlist.data_programme.map((subvalue, ind) => {
                                return <div style={{ display: subvalue.programe_key ? '' : 'none', fontWeight: this.state.filterchk === subvalue.programe_key ? '500' : '', backgroundColor: this.state.filterchk === subvalue.programe_key ? '#165E84' : '', color: this.state.filterchk === subvalue.programe_key ? 'white ' : '' }} onClick={() => this.setfilter('programe', subvalue.programe_key, subvalue.programe_name)} className='faculty_subfilter_value'>
                                  {subvalue.programe_name}
                                </div>
                              })}
                            </div> : ''}
                        </div>

                      })
                      : ''}
                  </div>
                  <div className='faculty_main'>
                    <div className="row">
                      <div className="region region-content">
                        <div className="view-wiki">

                          {/* {<div className='loading'>
                    <img src={load} alt='load'/>
                    </div>:''} */}

                          {!this.state.people ?
                            <Loader color="#165e84" loaded={false} className="spinner" /> : ''
                          }

                          {this.state.people ?
                            this.state.people.map((people, index) => {
                              return (
                                <div className="views-row col s6 m6 l2">
                                  <div className="field-content">
                                    <div className="img-head">
                                      <Link onClick={() => this.pagestore(this.state.offset)} to={{ pathname: '/faculty/' + `${people.title[0].replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${people.nid[0]}`, state: { link: people, img: people.field_image_url ? BASE + people.field_image_url[0] : pr } }}>
                                        <img typeof="foaf:Image" src={people.field_image_url ? BASE + people.field_image_url[0] : pr} alt="" />
                                      </Link>
                                    </div>
                                    <h2>
                                      <Link onClick={() => this.pagestore(this.state.offset)} to={{ pathname: '/faculty/' + `${people.title[0].replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${people.nid[0]}`, state: { link: people, img: people.field_image_url ? BASE + people.field_image_url[0] : pr } }}>
                                        <TruncateString text={people.title[0].charAt(0).toUpperCase() + people.title[0].slice(1)} truncateAt={100} />
                                      </Link>
                                    </h2>
                                  </div>
                                </div>)
                            }) : <List />}
                        </div>

                      </div>
                    </div>
                    {/* {this.state.people ? this.state.prev || this.state.next ?

                      <ul className="pagination">
                        <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                          <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                        <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                      </ul>

                      : '' : ''} */}
                  </div>
                </div>

              </div>

            </div>

          </div>



          <div>

            {/* responsive filter */}
            <div class="button-responsive">
              <button onClick={() => this.setState({
                fpopup: !this.state.fpopup
              })} class="filter">Filter</button>
              <i class="filter-icon"></i>
            </div>
            {/* MObile FIlter */}
            <div className='mobile_filter' style={{ display: this.state.fpopup ? '' : 'none' }}>
              <div className='mobile_filter_head' >
                <div>Filters</div>
                <div onClick={() => this.setState({
                  fpopup: !this.state.fpopup
                })}>X</div>
              </div>
              <div className="filter_block">
                <div className="filter_container">
                  <div className='faculty_filter'>
                    {this.state.filterlist ?
                      this.state.filterlist.data_faculty_type.map((value, ind) => {
                        return <div>
                          <div style={{ cursor: value.field_faculty_type === "Faculty" ? 'normal' : '', fontWeight: this.state.filterchk === value.field_faculty_type ? '500' : '', backgroundColor: this.state.filterchk === value.field_faculty_type ? '#165E84' : '', color: this.state.filterchk === value.field_faculty_type ? 'white ' : '' }} onClick={() => this.setfilter('faculty_type', value.field_faculty_type)} className='faculty_filter_value'>
                            {value.field_faculty_type ? value.field_faculty_type : 'All Faculty'}
                          </div>
                          {value.field_faculty_type === 'Faculty' ?
                            <div className='faculty_subfilter'>
                              {this.state.filterlist.data_programme.map((subvalue, ind) => {
                                return <div style={{ display: subvalue.programe_key ? '' : 'none', fontWeight: this.state.filterchk === subvalue.programe_key ? '500' : '', backgroundColor: this.state.filterchk === subvalue.programe_key ? '#165E84' : '', color: this.state.filterchk === subvalue.programe_key ? 'white ' : '' }} onClick={() => this.setfilter('programe', subvalue.programe_key, subvalue.programe_name)} className='faculty_subfilter_value'>
                                  {subvalue.programe_name}
                                </div>
                              })}
                            </div> : ''}
                        </div>
                      })
                      : ''}
                  </div>
                  <div class="button-responsive">
                    <button onClick={() => this.setState({
                      fpopup: !this.state.fpopup
                    })} class="filter">Apply Filter</button>
                    <i class="filter-icon"></i>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
        <div className="filterfooter">
          <Footer />
        </div>
      </div>
    )


  }

}

export default Faculty;
